import script from "./PrivacyView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrivacyView.vue?vue&type=script&lang=ts&setup=true"

import "./PrivacyView.vue?vue&type=style&index=0&id=6a3138dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3138dc"]])

export default __exports__